import React, { useEffect, useState } from "react";
import { Container, Col, Input, FormGroup, Label } from "reactstrap";
import { ArrowLeft, Bell, Edit, XIcon } from "assets";
import CustomButton from "components/CustomButton";
import { FiSearch } from "react-icons/fi";
import { FormInputs, FormSelects, FormSelectsAsync } from "components/FormInputSelect";
import { API_GET_MAMBOO, API_POST_MAMBOO, API_PUT_MAMBOO } from "services";
import debounce from 'lodash.debounce'
import CustomInput from "pages/auth/CustomInput";
import { Alert, AlertNotif } from "components/Alert";
import { useLocation, useNavigate } from "react-router-dom";
import { getCookie } from "services/cookies";
import useLoginStore from "hooks/useLoginStore";

const AddTransaksi = () => {
  const navigate = useNavigate()
  const { profile } = useLoginStore();
  const { state } = useLocation()
  const detailTransaksi = state ? state?.detailTransaksi[0] : null
  let currentPage = window.location.pathname.split('/')[2]
  const [statusTransaksi, setStatusTransaksi] = useState('')
  const [idTransaksi, setIdTransaksi] = useState('')
  const [noteBatal, setNoteBatal] = useState('')
  const [errorStatus, setErrorStatus] = useState(false)
  // const [currentPage, navigate] /transaksi/ = useState(window.location.pathname.split('/')[2])
  const [isDisabled, setIsDisabled] = useState(true);
  const [songOption, setSongOption] = useState([])
  const [isPpn, setIsPpn] = useState(detailTransaksi?.is_ppn === false ? false : true)
  const [ppn, setPpn] = useState(detailTransaksi?.is_ppn === false ? 0 : 11)
  const [selectedSong, setSelectedSong] = useState({
    label: "",
    value: "",
    data: {}
  })
  const [songDetail, setSongDetail] = useState(false)
  const [durasiOption, setDurasiOption] = useState([])
  const [lisenceOption, setLisenceOption] = useState([])
  const [projectOption, setProjectOption] = useState([])
  const [jenisProject, setJenisProject] = useState([])
  const [durasi, setDurasi] = useState({})
  const [tipeLisensi, setTipeLisensi] = useState({})
  const [detailProject, setDetailProject] = useState({
    jenis_project: [],
    durasi_lisensi: {},
    tipe_lisensi: {}
  })
  const [detailPenggunaan, setDetailPenggunaan] = useState({
    product_name: "",
    contact_person: "",
    title: "",
    contact_number: "",
    client: "",
    email: "",
    npwp_number: "",
    address: ""
  })
  const [discount, setDiscount] = useState({
    type: {
      value: "",
      label: ""
    },
    discount: ''
  })

  const [placedDiscount, setPlacedDiscount] = useState(null)
  const [adjustment, setAdjustment] = useState(detailTransaksi?.adjustment || 0)
  const [placedAdjust, setPlacedAdjust] = useState(null)
  const [readOnly, setReadOnly] = useState(false);


  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "5px",
      border: "1px solid var(--border)",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'var(--brand-surface)' : provided.backgroundColor
    }),
    // valueContainer: (provided, state) => ({
    //     ...provided,
    //     height: '20px',
    //     padding: '0 6px'
    // }),
    singleValue: (state) => ({
      marginLeft: '16px',
      gridArea: '1/1/2/3',
      maxWidth: '100%',
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      color: "hsl(0, 0%, 20%)",
      marginLeft: "16px",
      marginRight: "2px",
      boxSizing: "border-box"
    }),

    input: (provided, state) => ({
      ...provided,
      margin: "0px",
      padding: "16px",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      margin: "0px",
      padding: "16px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    })
  };

  const getSongDetail = async (id) => {
    await API_GET_MAMBOO.dynamic.getSongDetail(id)
      .then((res) => {
        if (detailTransaksi) {
          setSongOption([{ label: res.song_info.song_title, value: res.song_info.song_title, data: res }])
          setSelectedSong({ label: res.song_info.song_title, value: res.song_info.song_title, data: { ...res, song_id: id } })
          // console.log('test')
        }
        setSongDetail(res)
      })
  }

  const handleOnChange = (e) => {
    setSelectedSong(e)
    console.log(e)
    getSongDetail(e.data.song_id)
  }

  const onChangeDetail = (e, name) => {
    if (name === 'jenis_project') {
      const { checked, index } = e[0]

      let currentData = [...projectOption]
      currentData[index].checked = !checked
      // console.log({ currentData, dataIn: currentData[index] })
      return setProjectOption(currentData)
    }

    setDetailProject((prev) => ({ ...prev, [name]: e }))
  }

  const setOptions = (type) => {
    const { is_exclusive, is_monthly } = songDetail?.song_usage_option
    switch (type) {
      case 'durasi':
        const exclusive = [{ label: '1 - Year', value: '03' }]
        const monthly = [
          { label: '1 - Month', value: '04'},
          { label: '3 - Month', value: '01' },
          { label: '6 - Month', value: '02' },
          { label: '1 - Year', value: '03' },
        ]
        return is_monthly ? setDurasiOption(monthly) : setDurasiOption(exclusive)
      case 'lisensi':
        const nonExclusive = [{ label: 'Non - Exclusive', value: '01' }]
        const lisenceExclusive = [{ label: 'Exclusive', value: '02' }]
        const mix = [...nonExclusive, ...lisenceExclusive]
        return is_exclusive && is_monthly ? setLisenceOption(mix) : is_exclusive ? setLisenceOption(lisenceExclusive) : setLisenceOption(nonExclusive)
      case 'projek':
        const price = songDetail.price
        const hasParent = price.filter((val) => val.project_type_parent).map((data) => (
          {
            label: data.project_desc,
            value: data.price_id,
            price: data.price,
            parent: true,
            data
          }
        ))
        const noParent = price.filter((val) => !val.project_type_parent).map((data) => (
          {
            label: data.project_desc,
            value: data.price_id,
            price: data.price,
            parent: false,
            data
          }
        ))
        const iklanIndex = price.findIndex((val) => val.project_desc === 'Iklan')
        const iklan = {
          label: iklanIndex < 0 ? 'Iklan' : price[iklanIndex].project_desc,
          value: iklanIndex < 0 ? '' : price[iklanIndex].price,
          data: iklanIndex < 0 ? {} : price[iklanIndex],
          disabled: true,
        }
        let forOption = []
        if (hasParent.length > 0) {
          forOption = [...noParent, iklan, ...hasParent]
        } else {
          forOption = [...noParent]
        }

        forOption.forEach((val, index) => {
          val.index = index
          val.checked = false
        })

        if (detailTransaksi) {
          forOption.forEach((val) => {
            detailTransaksi.project.forEach((data) => {
              if (val.data.project_type === data.project_code && val.data.project_desc === data.project_name) {
                val.checked = true
              }
            })
          })
        }
        // console.log({ forOption, price, iklan, iklanIndex })
        return setProjectOption(forOption)
      default:
        break;
    }
  }


  const _loadOptions = (input, cb) => {
    if (!input) return cb([])
    API_GET_MAMBOO.dynamic.getSongByTitle(input)
      .then((res) => {
        setSongOption(res.map((val) => ({ label: val.song_title, value: val.song_title, data: val })))
        cb(res.map((val) => ({ label: val.song_title, value: val.song_title, data: val })))
      })
  }

  const loadOptions = debounce(_loadOptions, 1000)

  const onCheckLabel = (e, index) => {
    const { checked } = e.target
    let currentData = [...projectOption]
    currentData[index].checked = checked
    setProjectOption(currentData)
  }

  const labelFormatter = ({ value, label, data, index, checked }) => {
    return (
      <div className="option-label-custom" {...(data.project_type_parent && { style: { marginLeft: '16px' } })}>

        <div style={{ display: 'flex', gap: '10px' }}>
          <label className='checkbox'>
            <input type='checkbox' onChange={(e) => onCheckLabel(e, index)} checked={checked} disabled={data.price ? false : true} />
            <span className='checkmark'></span>
          </label>
          <span>{label}</span>
        </div>
        <span>{data.price ? `Rp. ${data.price?.toLocaleString('id-ID')}` : ""}</span>
      </div>
    )
  }

  const formatStatusLabel = ({ value, label, color }) => {
    return (
      <span style={{ color }}>{label}</span>
    )
  }

  const onChangeProject = (e) => {
    setJenisProject(e)
  }

  const onChangePenggunaan = (e) => {
    const { value, name } = e.target
    setDetailPenggunaan((prev) => ({ ...prev, [name]: value }))
  }

  const onChangeAdjust = (e) => {
    const regex = /[0-9]|\./

    if (!e.target) {
      return setAdjustment((prev) => ({ ...prev, type: e }))
    }
    let { value, name } = e.target

    value = value.replace('Rp. ', '')
    if (!regex.test(value[value.length - 1]) && value) return
    // console.log(value)
    setAdjustment((prev) => value.replaceAll('.', ''))
  }

  const checkValue = (opt) => {
    let isValueExist = false
    opt.forEach((val) => {
      if (val.checked && !val.disabled) {
        isValueExist = true
      }
    })
    return isValueExist
  }

  const checkIklan = (opt, u) => {
    let isIklan = false

    if (detailTransaksi && currentPage !== 'edit') {
      opt.forEach((val) => {
        if (val.project_code_parent) {
          isIklan = true
        }
      })
    } else {
      opt.forEach((val) => {
        if (val.checked && !val.disabled && val.parent) {
          isIklan = true
        }
      })
    }
    return isIklan
  }

  const removeValue = (index) => {

    let currentData = [...projectOption]
    currentData[index].checked = false
    setProjectOption(currentData)
  }

  const onChangeDiscount = (e) => {
    const regex = /[0-9]|\./

    if (!e.target) {
      return setDiscount((prev) => ({ ...prev, type: e }))
    }
    let { value, name } = e.target

    value = value.replace('Rp. ', '')
    if (!regex.test(value[value.length - 1]) && value) return
    // console.log(value)
    setDiscount((prev) => ({ ...prev, discount: value.replaceAll('.', '') }))
  }

  const placeDiscount = () => {
    if (detailTransaksi) {
      setPlacedDiscount(detailTransaksi)
    }
    setPlacedDiscount(discount.discount)
  }

  const placeAdjust = () => {
    if (detailTransaksi) {
      setPlacedAdjust(detailTransaksi)
    }
    setPlacedAdjust(adjustment)
  }

  const removeDiscount = () => {
    setPlacedDiscount("")
  }

  const removeAdjust = () => {
    setPlacedAdjust("")
  }

  const handleSwitch = (e) => {
    setIsPpn(!isPpn)
    if (isPpn) {
      setPpn(0)
    } else {
      setPpn(11)
    }
  }

  const getSubTotal = () => {
    let total = 0

    if(songDetail) {
      if(detailTransaksi) {
        total = 0
        detailTransaksi.project.forEach((val) => {
          total += val.project_amount
        })
        console.log(total, '1')
      }
      if(projectOption.filter((val) => val.checked && val.price).length > 0) {
        console.log('masuk atas proj opt')
        total = 0
        projectOption.forEach((val) => {
          if (val.checked && val.price) {
            total += val.price || 0
          }
          console.log(total, '2')
        })
      }
    } else {
      if(projectOption.filter((val) => val.checked && val.price).length > 0) {
        console.log('masuk atas proj opt')
        total = 0
        projectOption.forEach((val) => {
          if (val.checked && val.price) {
            total += val.price || 0
          }
          console.log(total, '3')
        })
      } else {
        if(detailTransaksi) {
          total = 0
          detailTransaksi.project.forEach((val) => {
            total += val.project_amount
          })
          console.log(total, '4')
        }
      }
    }


    if(detailTransaksi && !detailProject.durasi_lisensi.value) {
      switch (detailTransaksi.period_code) {
        case "01":
          total *= 0.50
          break;
        case "02":
          total *= 0.75
          break;
        case "04":
          total *= 0.25
          break;
      }
    }

    console.log(total, '5')
    if(detailProject.durasi_lisensi.value) {
      switch (detailProject.durasi_lisensi.value) {
        case "01":
          total *= 0.50
          break;
        case "02":
          total *= 0.75
          break;
        case "04":
          total *= 0.25
          break;
      }
    }
      

    console.log({songDetail, detailTransaksi, projectOption, total})
    // console.log(projectOption, 'ini proop')

    // console.log(detailProject.tipe_lisensi.value, detailTransaksi?.license_code)
    if (detailProject.tipe_lisensi.value === detailTransaksi?.license_code) {
      // console.log(total)
      return detailProject.tipe_lisensi.value === '02' || detailTransaksi?.license_code === '02' ? total * 5 : total
    }

    return detailProject.tipe_lisensi.value === '02' ? total * 5 : total
  }

  const getDiscount = (type) => {
    let totalDiscount = 0
    if (detailTransaksi && currentPage !== 'edit') {
      let { discount_amount, discount_pro, sub_total } = detailTransaksi
      switch (detailProject.durasi_lisensi.value) {
        case "01":
          sub_total *= 0.50
          break;
        case "02":
          sub_total *= 0.75
          break;
        case "04":
          sub_total *= 0.25
          break;
      }
      if (discount_amount) {
        if(type) {
          totalDiscount = discount_amount.toLocaleString("ID-id")
        } else {
          totalDiscount = discount_amount
        }
      } else {
        if(type) {
          totalDiscount = `${discount_pro}%`
        } else {
          const code = detailTransaksi.license_code === '01' ? 1 : 5
          totalDiscount = getSubTotal() * discount_pro / 100
        }
      }
    } else {
      if (discount.type.value === 'Persen' && placedDiscount) {
        if(type) {
          totalDiscount = `${placedDiscount}`
        } else {
          totalDiscount = getSubTotal() * placedDiscount / 100
        }
      } else {
        totalDiscount = placedDiscount
      }
    }

    if(typeof totalDiscount !== 'string') {
      console.log({totalDiscount, sub_total: getSubTotal()})
    }
    return totalDiscount
  }


  const createTransaksi = async (data) => {
    await API_POST_MAMBOO.actions.saveTransaksi(data)
      .then((res) => {
        setIdTransaksi(res.transaction_id)
        console.log(res, 'ini res')

        let total = 0

        projectOption.forEach((val) => {
          if (val.checked && val.price) {
            total += val.price || 0
          }
        })
        
        const forNavigate = {
          discount_amount: discount.type.label === 'Persen' ? null : discount.discount,
          discount_pro: discount.type.label === 'Persen' ? discount.discount : null,
          duration: detailProject.durasi_lisensi.value,
          license_code: detailProject.tipe_lisensi.value,
          license_type: detailProject.tipe_lisensi.label,
          period: detailProject.durasi_lisensi.label,
          period_code: detailProject.durasi_lisensi.value,
          ppn: total * ppn / 100,
          project: projectOption.filter((val) => val.data.price && val.checked).map((data) => {

            return {
              ...data,
              project_code: data.data.project_type,
              project_code_parent: data.data.project_type_parent || null,
              project_amount: data.data.price
            }
          }),
          song_id: res.song_id,
          adjustment: placedAdjust,
          song_title: selectedSong.label,
          status: res.status,
          status_desc: res.status_desc,
          sub_total: total,
          total_transaction: res.total_transaction,
          transaction_id: res.transaction_id,
          transaction_detail: {
            ...detailPenggunaan
          }
        }
        console.log(res, 'ini res')

        console.log(forNavigate, 'ini for navigate')
        
        AlertNotif({
          icon: 'success',
          title: 'Draft Transaksi berhasil disimpan'
        })
        navigate('/transaksi/summary', { state: { detailTransaksi: [forNavigate] } })
      })
  }

  const sendQuotation = async (id) => {
    // console.log(id, 'Quotation')
    let error;
    await API_POST_MAMBOO.actions.kirimEmail(id, 'Quotation')
      .then((res) => {
        // console.log(res)

        return API_GET_MAMBOO.dynamic.getDetailTransaksi(id)
      })
      .then((res) => {
        navigate('/transaksi/detail', { state: { detailTransaksi: [{ ...res[0] }] } })
      })
      .catch((err) => {
        error = err
      })

      if(error) return error
  }

  const sendInvoice = async (id) => {
    // console.log(id, 'Invoice')
    await API_POST_MAMBOO.actions.kirimEmail(id, 'Invoice')
      .then((res) => {
        // console.log(res)

        return API_GET_MAMBOO.dynamic.getDetailTransaksi(id)
      })
      .then((res) => {
        navigate('/transaksi/detail', { state: { detailTransaksi: [{ ...res[0] }] } })
      })
  }

  const updateStatus = async (id) => {
    const data = {
      status: statusTransaksi.value,
      note: noteBatal
    }
    // console.log({ id, data, statusTransaksi })
    await API_PUT_MAMBOO.update.updateStatusTransaksi(id, data)
      .then((res) => {
        // console.log(res)
        AlertNotif({
          icon: 'success',
          title: 'Status Transaksi berhasil diupdate',
        })
        return API_GET_MAMBOO.dynamic.getDetailTransaksi(id)
      })
      .then((res) => {
        navigate('/transaksi/detail', { state: { detailTransaksi: [{ ...res[0] }] } })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const editTransaksi = async (id, data) => {
    await API_PUT_MAMBOO.update.updateTransaksi(id, data)
      .then((res) => {
        console.log(res)

        AlertNotif({
          icon: 'success',
          title: `${detailTransaksi.status_desc} Transaksi berhasil diupdate`
        })
        navigate('/transaksi')
      })
      .catch((err) => console.log(err))
  }

  const handleSubmit = async () => {
    if (currentPage === 'create') {
      const payload = {
        transaction: {
          song_id: selectedSong.data.song_id,
          project_type: projectOption.filter((val) => val.data.price && val.checked).map((data) => {

            return {
              ...data,
              project_code: data.data.project_type,
              project_code_parent: data.data.project_type_parent || null,
              project_amount: data.data.price
            }
          }),
          duration: detailProject.durasi_lisensi.value,
          license_code: detailProject.tipe_lisensi.value,
          is_ppn: isPpn,
          adjustment
        },
        transaction_detail: { ...detailPenggunaan },
        discount: {
          discount_pro: discount.type.value === 'Persen' ? placedDiscount : null,
          discount_amount: discount.type.value !== 'Persen' ? placedDiscount : null
        }
      }
      // console.log(payload)
      await createTransaksi(payload)
      return
    }

    if (currentPage === 'edit' && (detailTransaksi.status_desc === 'Draft' || detailTransaksi.status_desc === 'Quotation')) {
      const selectedProject = projectOption.filter((val) => val.data.price && val.checked).map((data) => {
        let result = {
          project_id: "",
          project_code: data.data.project_type,
          project_code_parent: data.data.project_type_parent || null,
          project_amount: data.data.price
        }
        detailTransaksi.project.forEach((val) => {
          if (val.project_code === data.data.project_type && val.project_code_parent === data.data.project_type_parent) {
            result.project_id = val.project_id
          }
        })
        return result
      })
      const payloadEdit = {
        transaction: {
          song_id: selectedSong.data?.song_id || detailTransaksi.song_id,
          project_type: selectedProject,
          duration: detailProject.durasi_lisensi.value,
          license_code: detailProject.tipe_lisensi.value,
          is_ppn: isPpn,
          adjustment
        },
        transaction_detail: { ...detailPenggunaan },
        discount: {
          discount_pro: discount.type.value === 'Persen' ? placedDiscount : null,
          discount_amount: discount.type.value !== 'Persen' ? placedDiscount : null
        }
      }


      // console.log(payloadEdit, 'ini payload edit')
      // console.log(selectedSong)
      // ========= MASIH ADA YG BELUM BERUBAHNYA =========
      Alert({
        icon: 'warning',
        title: `Edit ${detailTransaksi.status_desc} Transaksi`,
        text: `Pastikan data yang anda isikan sudah benar`,
        showCancelButton: true,
        showConfirmButton: true,
        showLoaderOnConfirm: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Batal',
        confirmButtonColor: 'var(--danger)',
        successText: `${detailTransaksi.status_desc} Transaksi berhasil diedit`,
        failText: `${detailTransaksi.status_desc} Transaksi gagal diedit`,
        cancelText: `${detailTransaksi.status_desc} Transaksi batal diedit`,
        confirmed: () => editTransaksi(detailTransaksi?.transaction_id, payloadEdit)
      })
      return
    }

    Alert({
      icon: 'warning',
      title: 'Kirim Quotation',
      text: `Kirim Quotation untuk client '${detailPenggunaan.client}'`,
      showCancelButton: true,
      showConfirmButton: true,
      showLoaderOnConfirm: true,
      confirmButtonText: 'Ya',
      cancelButtonText: 'Batal',
      confirmButtonColor: 'var(--danger)',
      successText: `Quotation berhasil dikirim`,
      failText: `Quotation gagal dikirim`,
      cancelText: `Quotation batal dikirim`,
      confirmed: () => sendQuotation(detailTransaksi?.transaction_id)
    })
  }

  useEffect(() => {
    if (songDetail) {
      console.log('jalan')
      setOptions('durasi')
      setOptions('lisensi')
      setOptions('projek')
    }
  }, [songDetail]);

  useEffect(() => {
    getSubTotal()
  }, [detailProject])

  useEffect(() => {
    if (detailTransaksi) {
      console.log(currentPage)
      const {
        product_name,
        contact_person,
        title,
        contact_number,
        client,
        email,
        npwp_number,
        address
      } = detailTransaksi.transaction_detail
      setDetailPenggunaan((prev) => ({
        product_name,
        contact_person,
        title,
        contact_number,
        client,
        email,
        npwp_number,
        address
      }))
      if (detailTransaksi.status === '4') {
        setStatusTransaksi(
          {
            value: '4',
            label: 'Canceled - Transaksi Dibatalkan',
            color: '#BD251C'
          }
        )
      }
      if (detailTransaksi.status === '3') {
        setStatusTransaksi(
          {
            value: '3',
            label: 'Complete - Invoice Lunas',
            color: '#43936C'
          }
        )
      }
      getSongDetail(detailTransaksi.song_id)
      onChangeDetail({ label: detailTransaksi.period, value: detailTransaksi.period_code }, 'durasi_lisensi')
      onChangeDetail({ label: detailTransaksi.license_type, value: detailTransaksi?.license_code }, 'tipe_lisensi')
      setDiscount((prev) => ({
        ...prev, type: {
          value: detailTransaksi.discount_pro ? 'Persen' : 'Nominal Rupiah',
          label: detailTransaksi.discount_pro ? 'Persen' : 'Nominal Rupiah'
        },
      }))
      setPlacedDiscount(detailTransaksi.discount_pro || detailTransaksi.discount_amount)
      setPlacedAdjust(detailTransaksi.adjustment ? detailTransaksi.adjustment : null)
    }

    if(profile.access && profile?.access?.length > 0) {
      profile.access.filter((val) => {
        if(val.access_name === "Transaksi") {
          setReadOnly(val.is_read_only)
        } else if (val.access_name === "Super Admin") {
          setReadOnly(val.is_read_only)
        }
      })
    }
  }, [currentPage])
  return (
    <>
      <Container className="content-pencipta">
        <div className="header-content">
          <div className="pencipta-header">
            <h1 style={{ textTransform: "capitalize" }}>
              {currentPage}{" "}
              {detailTransaksi
                ? detailTransaksi.status_desc === "Selesai"
                  ? "Transaksi"
                  : detailTransaksi.status_desc === "Batal"
                  ? "Transaksi"
                  : detailTransaksi.status_desc
                : "Transaksi"}
            </h1>
          </div>
          <div className="icon-wrapper">
            <Bell />
          </div>
        </div>
        <div className="header-detail">
          <div
            className="container-kembali"
            onClick={() => navigate("/transaksi")}
          >
            <ArrowLeft style={{ stroke: 'var(--text-strong)' }} />
            <span className="text-kembali">Kembali</span>
          </div>

          {currentPage !== "create" && (
            <>
              {/* <div className='container-kembali' onClick={() => navigate('/transaksi')}>
                <ArrowLeft style={{ stroke: 'var(--text-strong)' }} />
                <span className='text-kembali'>Kembali</span>
              </div> */}
              {currentPage !== "edit" &&
                detailTransaksi.status_desc !== "Invoice" &&
                detailTransaksi.status_desc !== "Batal" &&
                detailTransaksi.status_desc !== "Selesai" && (
                  <div className="container-button d-flex gap-2">
                    {getCookie("publisher") == 3 || readOnly ? null : (
                      <button
                        onClick={() => {
                          currentPage = "edit";
                          navigate("/transaksi/edit", {
                            state: { detailTransaksi: [detailTransaksi] },
                          });
                        }}
                        style={{ textTransform: "capitalize" }}
                      >
                        <Edit /> Edit{" "}
                        {detailTransaksi
                          ? detailTransaksi.status_desc === "Selesai"
                            ? "Transaksi"
                            : detailTransaksi.status_desc === "Batal"
                            ? "Transaksi"
                            : detailTransaksi.status_desc
                          : detailTransaksi.status_desc}
                      </button>
                    )}
                    {readOnly ? null : currentPage !== 'summary' && 
                    detailTransaksi?.status_desc !== "Invoice" &&
                      getCookie("publisher") != 3 && (
                        <CustomButton
                          label={`Kirim ${
                            detailTransaksi.status_desc === "Draft"
                              ? "Quotation"
                              : "Invoice"
                          }`}
                          className="btn-simpan"
                          color="primary-btn"
                          style={{ color: 'var(--brand-contrast)' }}
                          onClick={() => {
                            if (detailTransaksi.status_desc === "Draft") {
                              Alert({
                                icon: "warning",
                                title: "Kirim Quotation",
                                text: `Kirim Quotation untuk client '${detailPenggunaan.client}'`,
                                showCancelButton: true,
                                showConfirmButton: true,
                                showLoaderOnConfirm: true,
                                confirmButtonText: "Ya",
                                cancelButtonText: "Batal",
                                confirmButtonColor: "var(--danger)",
                                successText: `Quotation berhasil dikirim`,
                                failText: `Quotation gagal dikirim`,
                                cancelText: `Quotation batal dikirim`,
                                confirmed: () =>
                                  sendQuotation(
                                    detailTransaksi?.transaction_id
                                  ),
                              });
                            } else {
                              Alert({
                                icon: "warning",
                                title: "Kirim Invoice",
                                text: `Kirim Invoice untuk client '${detailPenggunaan.client}'`,
                                showCancelButton: true,
                                showConfirmButton: true,
                                showLoaderOnConfirm: true,
                                confirmButtonText: "Ya",
                                cancelButtonText: "Batal",
                                confirmButtonColor: "var(--danger)",
                                successText: `Invoice berhasil dikirim`,
                                failText: `Invoice gagal dikirim`,
                                cancelText: `Invoice batal dikirim`,
                                confirmed: () =>
                                  sendInvoice(detailTransaksi?.transaction_id),
                              });
                            }
                          }}
                        />
                      )}
                  </div>
                )}
            </>
          )}
        </div>
        {/* <div className="tabs-filters">
          <div className="frame-filters">
            <CustomButton
              label="Kembali"
              size="md"
              iconPosition="left"
              LabelIcon={ArrowLeft}
              className="button-kembali"
              onClick={handleBack}
            />
          </div>
        </div> */}

        {currentPage === "detail" &&
          detailTransaksi.status_desc !== "Draft" && (
            <div
              className="frame-lainnya-password"
              style={{ margin: "32px 0px" }}
            >
              <div className="informasi-lainnya">
                <div className="text-lainnya">Proses Status Transaksi</div>
                <div
                  className="frame-lainnya d-flex gap-3"
                  style={{ flexDirection: "column" }}
                >
                  {/* <FormInputs
                placeholder="Masukkan Nama"
                className="frame-inputs"
                value={judulLagu}
                onChange={(e) => setJudulLagu(e.target.value)}
              /> */}
                  <div className="d-flex w-100 gap-3">
                    <FormSelects
                      placeholder="Pilih Status Transaksi"
                      formatOptionLabel={formatStatusLabel}
                      options={[
                        {
                          value: "3",
                          label: "Complete - Invoice Lunas",
                          color: "#43936C",
                        },
                        {
                          value: "4",
                          label: "Canceled - Transaksi Dibatalkan",
                          color: "#BD251C",
                        },
                      ]}
                      isDisabled={
                        currentPage === "detail" &&
                        detailTransaksi.status_desc !== "Invoice"
                      }
                      value={statusTransaksi.value}
                      onChange={(e) => setStatusTransaksi(e)}
                      styles={customStyles}
                    />
                    {(currentPage !== "detail" ||
                      detailTransaksi.status_desc === "Invoice") && (
                      <CustomButton
                        label="Update Status"
                        className="btn-simpan"
                        color="primary-btn"
                        disabled={statusTransaksi.value ? false : true}
                        style={{
                          color: 'var(--brand-contrast)',
                          whiteSpace: "nowrap",
                          alignSelf: "stretch",
                        }}
                        onClick={() =>
                          updateStatus(detailTransaksi?.transaction_id)
                        }
                      />
                    )}
                  </div>
                  {statusTransaksi.value === "4" && (
                    <div className="w-100 gap-2 d-flex flex-column">
                      <div className="text-telepon">
                        <span style={{ color: "red" }} className="text-telepon">
                          *{" "}
                        </span>
                        Tambahkan Note
                      </div>
                      <Input
                        type="textarea"
                        disabled={
                          currentPage === "detail" &&
                          detailTransaksi.status_desc !== "Invoice"
                        }
                        value={noteBatal}
                        onChange={(e) => {
                          setNoteBatal(e.target.value);
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

        <div className="frame-lainnya-password" style={{ margin: "32px 0px" }}>
          <div className="informasi-lainnya">
            <div className="text-lainnya">Cari Lagu</div>
            <div className="frame-lainnya" style={{ flexDirection: "row" }}>
              {currentPage === "detail" ? (
                <FormInputs
                  placeholder="Masukkan Nama"
                  className="frame-inputs"
                  isDisabled={true}
                  value={songDetail?.song_info?.song_title}
                />
              ) : (
                <FormSelectsAsync
                  placeholder="Masukkan Judul Lagu"
                  name="selectedSong"
                  isDisabled={
                    currentPage === "summary" ||
                    currentPage === "detail" ||
                    (currentPage === "edit" &&
                      detailTransaksi?.status_desc !== "Draft")
                  }
                  // className="frame-inputs"
                  defaultOptions={songOption}
                  options={songOption}
                  value={selectedSong.label}
                  onChange={handleOnChange}
                  styles={customStyles}
                  loadOptions={loadOptions}
                />
              )}
              {/* <div className="frame-search-nama">
                <FiSearch size={20} />
              </div> */}
            </div>
          </div>
        </div>

        <div className="frame-lainnya-password" style={{ margin: "32px 0px" }}>
          <div className="informasi-lainnya">
            <div className="text-lainnya">Detail Project</div>
            <div className="frame-lainnya">
              <FormSelects
                placeholder="Jenis Project"
                styles={customStyles}
                options={projectOption}
                formatOptionLabel={labelFormatter}
                isOptionDisabled={(option) => option.disabled}
                hideSelectedOptions={false}
                getOptionValue={(option) => `${option["label"]}`}
                getOptionLabel={(option) => `${option["label"]}`}
                isMulti
                isDisabled={
                  currentPage === "summary" || currentPage === "detail"
                }
                closeMenuOnSelect={false}
                value={jenisProject}
                onChange={(e) => onChangeDetail(e, "jenis_project")}
              />

              {detailTransaksi &&
                (currentPage === "detail" || currentPage === "summary") && (
                  <div className="value-outer">
                    <div className="value-container">
                      {detailTransaksi.project.map((val, index) => (
                        <>
                          {!val.project_code_parent && (
                            <div className="no-parent">
                              <span>{val.project_name || val.label}</span>
                            </div>
                          )}
                        </>
                      ))}
                    </div>
                    {checkIklan(detailTransaksi.project, 'detail summ') && (
                      <div className="value-container">
                        <div className="has-parent">Iklan Untuk :</div>
                        {detailTransaksi.project.map((val, index) => (
                          <>
                            {val.project_code_parent && (
                              <div className="has-parent">
                                <span>{val.project_name || val.label}</span>
                              </div>
                            )}
                          </>
                        ))}
                      </div>
                    )}
                  </div>
                )}

              {checkValue(projectOption) && currentPage !== "detail" && (
                <div className="value-outer">
                  <div className="value-container">
                    {projectOption.map((val, index) => (
                      <>
                        {val.checked && !val.parent && (
                          <div className="no-parent">
                            <span>{val.label}</span>
                            <div
                              role="button"
                              onClick={() => removeValue(index)}
                            >
                              <XIcon />
                            </div>
                          </div>
                        )}
                      </>
                    ))}
                  </div>
                  {checkIklan(projectOption, 'edit') && (
                    <div className="value-container">
                      <div className="has-parent">Iklan Untuk :</div>
                      {projectOption.map((val, index) => (
                        <>
                          {val.checked && val.parent && (
                            <div className="has-parent">
                              <span>{val.label}</span>
                              <div
                                role="button"
                                onClick={() => removeValue(index)}
                              >
                                <XIcon />
                              </div>
                            </div>
                          )}
                        </>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="frame-lainnya">
              <FormSelects
                name="durasi_lisensi"
                placeholder="Durasi Lisensi"
                styles={customStyles}
                isDisabled={
                  currentPage === "summary" || currentPage === "detail"
                }
                options={durasiOption}
                value={detailProject.durasi_lisensi.value}
                onChange={(e) => onChangeDetail(e, "durasi_lisensi")}
              />
            </div>
            <div className="frame-lainnya">
              <FormSelects
                name="tipe_lisensi"
                placeholder="Tipe Lisensi"
                styles={customStyles}
                isDisabled={
                  currentPage === "summary" || currentPage === "detail"
                }
                options={lisenceOption}
                value={detailProject.tipe_lisensi.value}
                onChange={(e) => onChangeDetail(e, "tipe_lisensi")}
              />
            </div>
          </div>
        </div>

        <div className="scope-container">
          <div className="frame-lainnya-password">
            <div className="informasi-lainnya">
              <div className="text-lainnya">Detail Penggunaan</div>
              <div className="frame-lainnya">
                <div className="text-telepon">
                  <span style={{ color: "red" }} className="text-telepon">
                    *{" "}
                  </span>
                  Nama Produk
                </div>
                <FormInputs
                  placeholder="Cth Iklan makanan cepat saji"
                  isDisabled={
                    currentPage === "summary" || currentPage === "detail"
                  }
                  className="frame-inputs"
                  name="product_name"
                  value={detailPenggunaan.product_name}
                  onChange={onChangePenggunaan}
                />
              </div>
              <div className="frame-lainnya">
                <div className="text-telepon">
                  <span style={{ color: "red" }} className="text-telepon">
                    *{" "}
                  </span>
                  Kepada
                </div>
                <FormInputs
                  placeholder="Cth PT. Saji Indonesia"
                  isDisabled={
                    currentPage === "summary" || currentPage === "detail"
                  }
                  className="frame-inputs"
                  name="client"
                  value={detailPenggunaan.client}
                  onChange={onChangePenggunaan}
                />
              </div>
              <div className="frame-lainnya">
                <div className="text-telepon">
                  <span style={{ color: "red" }} className="text-telepon">
                    *{" "}
                  </span>
                  Penanggung Jawab (PIC)
                </div>
                <FormInputs
                  placeholder="Penanggung Jawab (PIC)"
                  isDisabled={
                    currentPage === "summary" || currentPage === "detail"
                  }
                  className="frame-inputs"
                  name="contact_person"
                  value={detailPenggunaan.contact_person}
                  onChange={onChangePenggunaan}
                />
              </div>
              {getCookie("publisher") == 3 ? null : (
                <>
                  <div className="frame-lainnya">
                    <div className="text-telepon">
                      <span style={{ color: "red" }} className="text-telepon">
                        *{" "}
                      </span>
                      Title
                    </div>
                    <FormInputs
                      placeholder="Title"
                      isDisabled={
                        currentPage === "summary" || currentPage === "detail"
                      }
                      className="frame-inputs"
                      name="title"
                      value={detailPenggunaan.title}
                      onChange={onChangePenggunaan}
                    />
                  </div>
                  <div className="content-input">
                    <div className="subcontent-input">
                      <div className="text-input">
                        <span style={{ color: "red" }} className="text-telepon">
                          *{" "}
                        </span>
                        No Contact
                      </div>
                      <FormInputs
                        placeholder="No Contact"
                        isDisabled={
                          currentPage === "summary" || currentPage === "detail"
                        }
                        className="frame-inputs"
                        name="contact_number"
                        value={detailPenggunaan.contact_number}
                        onChange={onChangePenggunaan}
                      />
                    </div>
                    <div className="subcontent-input">
                      <div className="text-input">
                        <span style={{ color: "red" }} className="text-telepon">
                          *{" "}
                        </span>
                        Email
                      </div>
                      <FormInputs
                        placeholder="Email"
                        isDisabled={
                          currentPage === "summary" || currentPage === "detail"
                        }
                        className="frame-inputs"
                        name="email"
                        value={detailPenggunaan.email}
                        onChange={onChangePenggunaan}
                      />
                    </div>
                  </div>
                  <div className="frame-lainnya">
                    <div className="text-telepon">
                      <span style={{ color: "red" }} className="text-telepon">
                        *{" "}
                      </span>
                      No NPWP
                    </div>
                    <FormInputs
                      placeholder="NPWP Number"
                      isDisabled={
                        currentPage === "summary" || currentPage === "detail"
                      }
                      className="frame-inputs"
                      name="npwp_number"
                      value={detailPenggunaan.npwp_number}
                      onChange={onChangePenggunaan}
                    />
                  </div>
                </>
              )}
              <div className="frame-lainnya">
                <div className="text-telepon">
                  <span style={{ color: "red" }} className="text-telepon">
                    *{" "}
                  </span>
                  Alamat
                </div>
                <FormInputs
                  placeholder="Address"
                  className="frame-inputs"
                  isDisabled={
                    currentPage === "summary" || currentPage === "detail"
                  }
                  name="address"
                  value={detailPenggunaan.address}
                  onChange={onChangePenggunaan}
                />
              </div>
            </div>
          </div>

          <div className="frame-bank-verified">
            {currentPage !== "detail" && (
              <>
              <div className="data-bank" style={{ flex: "1 0" }}>
                <div className="text-data-bank">Diskon</div>
                <FormSelects
                  placeholder="Pilih Diskon Berdasarkan"
                  isDisabled={
                    currentPage === "summary" || currentPage === "detail"
                  }
                  styles={customStyles}
                  options={[
                    { value: "Nominal Rupiah", label: "Nominal Rupiah" },
                    { value: "Persen", label: "Persen" },
                  ]}
                  onChange={onChangeDiscount}
                  value={discount.type.value}
                />

                <CustomInput
                  type="text"
                  placeholder="Masukan diskon"
                  name="discount"
                  value={
                    discount.type.value === "Nominal Rupiah"
                      ? `${discount.discount ? "Rp. " : ""}${
                          discount.discount
                            ? Number(discount.discount).toLocaleString("id-ID")
                            : ""
                        }`
                      : discount.discount
                  }
                  disabled={
                    currentPage === "summary" || currentPage === "detail"
                  }
                  onChange={onChangeDiscount}
                  hasButton={true}
                  otherButtonLabel="Terapkan"
                  buttonAction={placeDiscount}
                />
                {placedDiscount && (
                  <div className="discount-container">
                    <span className="discount-text">
                      {`${
                        discount.type.value === "Persen"
                          ? placedDiscount + "%"
                          : "Rp. " +
                            Number(placedDiscount).toLocaleString("id-ID")
                      }`}
                    </span>
                    <div role="button" onClick={removeDiscount}>
                      <XIcon stroke="#3267E3" width={24} height={24} />
                    </div>
                  </div>
                )}
              </div>

              <div className="data-bank" style={{ flex: "1 0" }}>
                <div className="text-data-bank">Adjustment Harga</div>

                <CustomInput
                  type="text"
                  placeholder="Masukan adjustment harga"
                  name="adjustment"
                  value={adjustment ? `Rp. ${Number(adjustment).toLocaleString("id-ID")}` : ""}
                  disabled={
                    currentPage === "summary" || currentPage === "detail"
                  }
                  onChange={onChangeAdjust}
                  hasButton={true}
                  otherButtonLabel="Terapkan"
                  buttonAction={placeAdjust}
                />
                {placedAdjust && (
                  <div className="discount-container">
                    <span className="discount-text">Rp. {Number(placedAdjust).toLocaleString("id-ID")}</span>
                    <div role="button" onClick={removeAdjust}>
                      <XIcon stroke="#3267E3" width={24} height={24} />
                    </div>
                  </div>
                )}
              </div>
              </>
            )}

            <div
              className="data-bank"
              {...(currentPage === "create" && { style: { flex: "1 0 auto" } })}
            >
              <div className="text-data-bank">Ringkasan</div>
              <Col style={{ width: "100%" }}>
                <div className="form-transaksi">
                  <div
                    className="text-telepon"
                    style={{ whiteSpace: "nowrap", fontWeight: "600" }}
                  >
                    Nilai Royalti
                  </div>
                  <Input
                    className="form-input-rupiah"
                    // value={
                    //   detailTransaksi && currentPage !== "edit"
                    //     ? `Rp. ${(
                    //         detailTransaksi?.sub_total * 5
                    //       ).toLocaleString("ID-id")}`
                    //     : `Rp. ${Number(getSubTotal()).toLocaleString("ID-id")}`
                    // }
                    value={`Rp. ${Number(getSubTotal()).toLocaleString("ID-id")}`}
                    placeholder="Rp.0"
                    disabled
                  />
                </div>
                <div className="form-transaksi">
                  <div
                    className="text-telepon"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Diskon{" "}
                    {detailTransaksi?.discount_pro && placedDiscount && discount.type.value === "Persen" ? (
                      <b>({getDiscount("ringkasan")}%)</b>
                    ) : discount.type.value === "Persen" && placedDiscount ? (
                      <b>({placedDiscount}%)</b>
                    ) : null}
                  </div>
                  <Input
                    className="form-input-rupiah"
                    value={
                      detailTransaksi && currentPage !== "edit"
                        ? `Rp. ${getDiscount()?.toLocaleString("ID-id")}`
                        : `Rp. ${Number(getDiscount()).toLocaleString("ID-id")}`
                    }
                    // value={getDiscount('ringkasan')}
                    placeholder="Rp. 0"
                    disabled
                  />
                </div>
                <div className="form-transaksi">
                  <div
                    className="text-telepon"
                    style={{ whiteSpace: "nowrap", fontWeight: "600" }}
                  >
                    Lainnya
                  </div>
                  <Input
                    className="form-input-rupiah"
                    placeholder="Rp. 0"
                    value={`Rp. ${Number(placedAdjust).toLocaleString("ID-id")}`}
                    disabled
                  />
                </div>
                <div className="form-transaksi">
                  <div
                    className="text-telepon"
                    style={{ whiteSpace: "nowrap", fontWeight: "600" }}
                  >
                    Sub Total
                  </div>
                  <Input
                    className="form-input-rupiah"
                    // value={
                    //   detailTransaksi && currentPage !== "edit"
                    //     ? `Rp. ${Number(
                    //         detailTransaksi?.sub_total * 5 - getDiscount()
                    //       ).toLocaleString("ID-id")}`
                    //     : `Rp. ${Number(
                    //         getSubTotal() - getDiscount()
                    //       ).toLocaleString("ID-id")}`
                    // }
                    value={`Rp. ${Number(
                              getSubTotal() + Number(placedAdjust) - getDiscount()
                            ).toLocaleString("ID-id")}`}
                    placeholder="Rp.0"
                    disabled
                  />
                </div>
                <div className="form-transaksi">
                  <div
                    className="text-telepon"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    PPn(11%)
                  </div>
                  <Input
                    className="form-input-rupiah"
                    // value={
                    //   detailTransaksi && currentPage !== "edit"
                    //     ? `Rp. ${(detailTransaksi?.ppn * 5).toLocaleString(
                    //         "ID-id"
                    //       )}`
                    //     : `Rp. ${Number(
                    //         (getSubTotal() * ppn) / 100
                    //       ).toLocaleString("ID-id")}`
                    // }
                    value={`Rp. ${Number(
                              ((getSubTotal() - getDiscount() + Number(placedAdjust)) * ppn) / 100
                            ).toLocaleString("ID-id")}`}
                    valuplaceholder="Rp. 0"
                    disabled
                  />
                </div>
                <FormGroup switch>
                  <Input
                    onChange={handleSwitch}
                    checked={isPpn}
                    type="switch"
                    role="switch"
                    disabled={
                      currentPage === "summary" || currentPage === "detail"
                    }
                  />
                  <Label check>{isPpn ? "Disable" : "Enable"} PPN</Label>
                </FormGroup>
                <div className="form-transaksi" style={{ border: "none" }}>
                  <div
                    className="text-telepon"
                    style={{
                      whiteSpace: "nowrap",
                      fontWeight: "700",
                      fontSize: "20px",
                    }}
                  >
                    Total Harga
                  </div>
                  <Input
                    className="form-input-rupiah"
                    value={`Rp. ${(Number(
                      getSubTotal() + Number(placedAdjust) +
                        ((getSubTotal() - getDiscount() + Number(placedAdjust)) * ppn) / 100 -
                        getDiscount()
                    )).toLocaleString("ID-id")}`}
                    placeholder="Rp. 0"
                    disabled
                    style={{ fontWeight: "700", fontSize: "20px" }}
                  />
                </div>
              </Col>
            </div>

            {(currentPage === "summary" || currentPage === "detail") && (
              <div className="data-bank" style={{ flex: "4 0" }}>
                <div className="text-data-bank">Preview Document</div>

                <div className="file-container">
                  <span
                    className="file-text"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (detailTransaksi?.status_desc === "Draft") return;
                      window.open(
                        `${process.env.REACT_APP_API_URL_SERVER}/api/transaction/quotation/${detailTransaksi?.transaction_id}`,
                        "_blank"
                      );
                    }}
                  >
                    {detailTransaksi?.status_desc !== "Draft"
                      ? `Quotation - "${
                          detailTransaksi?.transaction_detail.product_name
                        }"${
                          detailTransaksi?.requote > 1
                            ? " V" + detailTransaksi?.requote
                            : ""
                        }.pdf`
                      : "Tidak ada dokumen"}
                  </span>
                </div>

                <div className="file-container">
                  <span
                    className="file-text"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (
                        detailTransaksi?.status_desc === "Draft" ||
                        detailTransaksi?.status_desc === "Quotation"
                      )
                        return;
                      let newBlob = new Blob([]);
                      window.open(
                        `${process.env.REACT_APP_API_URL_SERVER}/api/transaction/invoice/${detailTransaksi?.transaction_id}`,
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                  >
                    {detailTransaksi?.status_desc !== "Draft" &&
                    detailTransaksi?.status_desc !== "Quotation"
                      ? `Invoice - "${detailTransaksi?.transaction_detail.product_name}".pdf`
                      : "Tidak ada dokumen"}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="frame-button-simpan">
          {currentPage === "summary" && (
            <CustomButton
              label="Kembali"
              className=" button-import btn-simpan me-2"
              onClick={
                detailTransaksi
                  ? () =>
                      navigate("/transaksi/edit", {
                        state: { detailTransaksi: [detailTransaksi] },
                      })
                  : () => navigate("/transaksi/create")
              }
            />
          )}
          {currentPage !== "detail" && getCookie("publisher") != 3 && (
            <CustomButton
              label={
                currentPage === "summary"
                  ? "Kirim Quotation dan Perjanjian"
                  : currentPage === "create"
                  ? "Buat Transaksi"
                  : detailTransaksi.status_desc === "Draft"
                  ? "Simpan Perubahan Draft"
                  : "Kirim ulang Quotation dan Perjanjian"
              }
              color={false ? "secondary-btn" : "primary-btn"}
              className="btn-simpan"
              style={{ whiteSpace: "nowrap" }}
              disabled={false ? true : false}
              onClick={handleSubmit}
            />
          )}
        </div>
      </Container>
    </>
  );
};

export default AddTransaksi;
